var path = 'areas/configuration/teams/views/add_members_dialog.html';
var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Add team members</h3> </div> <div class=modal-body> <loading-wrapper busy=isLoading> <control-group label=Users> <select-users ng-model=adding.members available=users placeholder=\"'Any User'\" multiple=true></select-users> </control-group> </loading-wrapper> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=save() ng-show=!isLoading.busy>Add</button> <button class=\"btn btn-default\" ng-click=close()>Cancel</button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/views/add_members_dialog.html
// module id = 5661433844352888
// module chunks = 1